import EventEmitter from "events"

export default class FirebaseSubscriptionRef {
  constructor(ref) {
    console.log("FirebaseSubscriptionRef created")
    this.ref = ref
    const ee = new EventEmitter()
    ee.once("newListener", event => {
      ee.on("removeListener", event => {
        if (event === "value" && ee.listenerCount("value") === 0) {
          this.ref.off("value", this.subscription)
          console.log("FirebaseSubscriptionRef deleted")
        }
      })
      if (event === "value") {
        this.subscription = this.ref.on("value", snapshot => {
          ee.emit("value", snapshot.val())
        })
      }
    })
    return ee
  }
}
